/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

export const DISPATCH_BUSINESS_EVENT = 'DISPATCH_BUSINESS_EVENT';
export const dispatchBusinessEvent = (payload) => ({
  type: DISPATCH_BUSINESS_EVENT,
  payload
});

export const UPDATE_SUBSCRIPTIONS = 'UPDATE_SUBSCRIPTIONS';
export const updateSubscriptions = (subscription) => ({
  type: UPDATE_SUBSCRIPTIONS,
  subscription
});

export const SAVE_SUBSCRIPTIONS_SUCCESS = 'SAVE_SUBSCRIPTIONS_SUCCESS';
export const saveSubscriptionsSuccess = (response) => ({
  type: SAVE_SUBSCRIPTIONS_SUCCESS,
  response
});

export const SAVE_SUBSCRIPTIONS_ERROR = 'SAVE_SUBSCRIPTIONS_ERROR';
export const saveSubscriptionsError = (error) => ({
  type: SAVE_SUBSCRIPTIONS_ERROR,
  error
});

export const RECEIVED_SUBSCRIPTIONS = 'RECEIVED_SUBSCRIPTIONS';
export const receivedSubscriptions = (subscriptions) => ({
  type: RECEIVED_SUBSCRIPTIONS,
  subscriptions
});

export const REQUESTED_SUBSCRIPTIONS = 'REQUESTED_SUBSCRIPTIONS';
export const requestedSubscriptions = () => ({
  type: REQUESTED_SUBSCRIPTIONS
});

export const REQUESTED_UPDATE_SUBSCRIPTIONS = 'REQUESTED_UPDATE_SUBSCRIPTIONS';
export const requestedUpdateSubscriptions = () => ({
  type: REQUESTED_UPDATE_SUBSCRIPTIONS
});

export const RECEIVED_UPDATE_SUBSCRIPTIONS = 'RECEIVED_UPDATE_SUBSCRIPTIONS';
export const receivedUpdateSubscriptions = (updatedSubscriptions) => ({
  type: RECEIVED_UPDATE_SUBSCRIPTIONS,
  updatedSubscriptions
});

export const ERROR_UPDATE_SUBSCRIPTIONS = 'ERROR_UPDATE_SUBSCRIPTIONS';
export const errorUpdateSubscriptions = () => ({
  type: ERROR_UPDATE_SUBSCRIPTIONS
});
